/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable func-names */
import { deprecatedMsg } from './deprecatedMsg.js';

export const resetTimer = (func: (...args: unknown[]) => unknown) => {
  console.warn(`resetTimer ${deprecatedMsg}`);
  let timeout: NodeJS.Timeout | null;
  return function (this: any, ...args: unknown[]) {
    const lastCall = () => {
      timeout = null;
      func.apply(this, args);
    };

    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(lastCall, 300);
  };
};
